import styled from 'styled-components';

export const StyledSignInBackground = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;

  .sib-header {
    position: absolute;
    top: 43px;
    right: 64px;
    height: 24px;
    background-color: blue;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &-play {
      position: absolute;
      left: -64px;
      top: -25px;
      cursor: pointer;
    }

    .swiper-pagination {
      position: absolute;
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: center;
      bottom: 32px !important;
      width: inherit !important;
      left: -40px !important;
    }

    .swiper-pagination-bullet {
      width: 10px !important;
      height: 10px;
      background: rgba(255, 255, 255, 0.5);
      opacity: 1;
      transition: all 0.3s ease;
      border-radius: 50%;
      cursor: pointer;
    }

    .swiper-pagination-bullet-active {
      width: 35px !important;
      background: #ffffff !important;
      border-radius: 8px !important;
    }
  }

  .swiper-slide {
    position: relative;
    height: 100%;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    > img {
      width: 100vw;
      height: 100vh;
    }
  }
`;
